import React from 'react'

import google_reviews from '../../images/reviews.svg'

const GoogleReviewsBadge = () => {
  return <img src={google_reviews} alt="4.8/5 based on 373 Google reviews" />
}

export default GoogleReviewsBadge
